import Constants from '../../globals/Constants';
import Config from '../../globals/Config';

const isValidEmail = (email: string): boolean => {
   return email.length <= Constants.email.maxLength && Config.emailAddressValidationRegex.test(email);
};

export default {
   isValidEmail
};